  // Script for trustpilot reviews with custom Lambda Function
  function trustpilotLambdaFunction() {
    const apiUrl = 'https://k511wxtg3c.execute-api.eu-north-1.amazonaws.com/default/fetchTrustpilotData/trustpilot-data';

    // Function to create star rating element with specified star image URL
    function createStarRatingElement(starImageUrl) {
      const starRatingElement = document.createElement('div');
      starRatingElement.classList.add('trustpilot-item__stars');

      const starImage = document.createElement('img');
      starImage.src = starImageUrl.startsWith('//') ? `https:${starImageUrl}` : starImageUrl;
      starImage.alt = 'Star Rating';
      starRatingElement.appendChild(starImage);

      return starRatingElement;
    }  

  // Function to display store badge
  function storeBadge(totalReviews, representationValue, logoImageUrl, starImageUrl) {
    const badgeContainers = document.querySelectorAll('.trustpilotBadgeContainer');

    badgeContainers.forEach(badgeContainer => {
      const badgeElement = document.createElement('a');
      badgeElement.className = 'full-unstyled-link linktrustpilotReviewLink c-trustpilot-badge';
      badgeElement.href = 'https://uk.trustpilot.com/review/mobilityco.co.uk';
      badgeElement.target = '_blank';
      badgeElement.title = 'Read all our TrustPilot Reviews';
      badgeElement.rel = 'noopener';      

      const representationValueParagraph = document.createElement('span');
      representationValueParagraph.className = 'starStringRepresentation-value c-trustpilot-badge_title';
      representationValueParagraph.textContent = `${representationValue}`;
      badgeElement.appendChild(representationValueParagraph);

      const starImage = document.createElement('img');
      starImage.className = 'starImage-value';
      starImage.src = starImageUrl;
      starImage.alt = 'Trustpilot Star Rating';
      starImage.width = 128;
      starImage.height = 24;
      badgeElement.appendChild(starImage);

      const totalReviewsContainer = document.createElement('span');
      totalReviewsContainer.className = 'totalReviews-value c-trustpilot-badge_reviews';

      // Prefix "Based on"
      const basedOnText = document.createElement('span');
      basedOnText.textContent = 'Based on ';
      totalReviewsContainer.appendChild(basedOnText);

      // Group "Total reviews count" and "Suffix Reviews" within a single span
      const reviewsGroup = document.createElement('span');
      reviewsGroup.className = 'reviewGroup-value';

      // Total reviews count
      const totalReviewsCount = document.createElement('span');
      totalReviewsCount.textContent = totalReviews.toLocaleString();
      reviewsGroup.appendChild(totalReviewsCount);

      // Suffix "Reviews"
      const reviewsText = document.createElement('span');
      reviewsText.textContent = ' Reviews';
      reviewsGroup.appendChild(reviewsText);

      totalReviewsContainer.appendChild(reviewsGroup);

      badgeElement.appendChild(totalReviewsContainer);

      const logoImage = document.createElement('img');
      logoImage.className = 'logoImage-value';
      logoImage.src = logoImageUrl;
      logoImage.alt = 'Trustpilot Logo';
      logoImage.width = 144;
      logoImage.height = 36;
      badgeElement.appendChild(logoImage);

      // Add the mandatory text below the logo image
      const mandatoryText = document.createElement('p');
      mandatoryText.className = 'tpMandatoryText';
      mandatoryText.textContent = "Showing our 4 & 5 star reviews";
      badgeElement.appendChild(mandatoryText);

      badgeContainer.appendChild(badgeElement);
    });
  }

    // Function to format the date as "6th Feb 2024"
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const monthNames = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const monthIndex = date.getMonth();
      const year = date.getFullYear();

      // Function to add "st", "nd", "rd", or "th" to the day
      function getDayWithSuffix(day) {
          if (day >= 11 && day <= 13) {
              return day + 'th';
          }
          switch (day % 10) {
              case 1: return day + 'st';
              case 2: return day + 'nd';
              case 3: return day + 'rd';
              default: return day + 'th';
          }
      }

      return `${getDayWithSuffix(day)} ${monthNames[monthIndex]} ${year}`;
    }

    // Fetch Trustpilot data from custom Lambda function
    fetch(apiUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        if (!data.reviews || data.reviews.length === 0) {
          console.error('No reviews found in response data');
          return;
        }

        // Call storeBadge to display badge data
        storeBadge(data.totalReviews, data.starStringRepresentation, data.logoImageUrl, data.starImageUrl);      

        const reviewsContainer = document.getElementById('reviews-container');
        data.reviews.forEach(review => {
          
          if (review.text.length > 20 && (review.stars >= 4 && review.stars <= 5)) {
            const reviewItem = document.createElement('div');
            reviewItem.className = 'trustpilot-item';

            const starRatingElement = createStarRatingElement(review.starImageUrl);
            reviewItem.appendChild(starRatingElement);

            const titleElement = document.createElement('div');
            titleElement.className = 'trustpilot-item__title';
            titleElement.textContent = review.title;
            reviewItem.appendChild(titleElement);

            const textElement = document.createElement('div');
            textElement.className = 'trustpilot-item__content';
            
            textElement.textContent = review.text.length > 160 ? `${review.text.substring(0, 160)}...` : review.text;
            reviewItem.appendChild(textElement);

            const authorElement = document.createElement('div');
            authorElement.className = 'trustpilot-item__author';
            const createdAtDate = new Date(review.createdAt);
            const formattedDate = formatDate(createdAtDate);
            authorElement.textContent = `${review.consumer.displayName}, ${formattedDate}`;
            reviewItem.appendChild(authorElement);
            reviewsContainer.appendChild(reviewItem);
          }
        });
      })
      .catch(error => console.error('Error fetching Trustpilot data:', error));
  }

  document.addEventListener('DOMContentLoaded', trustpilotLambdaFunction);

  // Script for custom review scroll
  function reviewScroll() {
    const scrollButtonLeft = document.getElementById('scroll-left');
    const scrollButtonRight = document.getElementById('scroll-right');

    // Function to scroll the reviews one item at a time to the left
    scrollButtonLeft.addEventListener('click', function() {
      const slider = document.querySelector('.trustpilot-items .reviews-slider');
      slider.scrollBy({
        left: -slider.offsetWidth,
        behavior: 'smooth',
      });
    });

    // Function to scroll the reviews one item at a time to the right
    scrollButtonRight.addEventListener('click', function() {
      const slider = document.querySelector('.trustpilot-items .reviews-slider');
      slider.scrollBy({
        left: slider.offsetWidth,
        behavior: 'smooth',
      });
    });
  }
  document.addEventListener('DOMContentLoaded', reviewScroll);